import { useState, useRef, useCallback } from 'react';
import { supabase } from './supabase';

export function useAutocomplete(table, column, filterColumn, orgId) {
  const [suggestions, setSuggestions] = useState([]);
  const timer = useRef(null);
  const cache = useRef({});

  const search = useCallback((query, filterValue) => {
    if (!query || query.length < 2 || !orgId) { setSuggestions([]); return; }

    clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      const cacheKey = `${filterValue || ''}:${query.toLowerCase()}`;
      if (cache.current[cacheKey]) { setSuggestions(cache.current[cacheKey]); return; }

      let q = supabase.from(table).select(column).ilike(column, `%${query}%`);
      if (filterColumn && filterValue) q = q.eq(filterColumn, filterValue);
      const { data } = await q.limit(20);

      if (data) {
        // Deduplicate and sort by frequency
        const counts = {};
        data.forEach(r => {
          const val = r[column];
          if (val) counts[val] = (counts[val] || 0) + 1;
        });
        const results = Object.entries(counts)
          .sort((a, b) => b[1] - a[1])
          .map(([val]) => val)
          .slice(0, 8);
        cache.current[cacheKey] = results;
        setSuggestions(results);
      }
    }, 200);
  }, [table, column, filterColumn, orgId]);

  const clear = useCallback(() => setSuggestions([]), []);

  return { suggestions, search, clear };
}
